@let element = view();

@let suffix = is_retail() ? '_GIFT' : '';

<div class="promo-banner">
    @if(element?.banner_desktop){
        <picture>
            @if(('LANG' | translate) == 'mt'){
                <source [srcset]="element.banner_desktop_maltese | bucket:true" media="(min-width: 900px)">
                <source [srcset]="element.banner_desktop_maltese | bucket" media="(min-width: 900px)">
                <source [srcset]="element.banner_mobile_maltese | bucket:true" media="(max-width: 900px)">
                <source [srcset]="element.banner_mobile_maltese | bucket" media="(max-width: 900px)">
            }
            <source [srcset]="element.banner_desktop | bucket:true" media="(min-width: 900px)">
            <source [srcset]="element.banner_desktop | bucket" media="(min-width: 900px)">
            <source [srcset]="element.banner_mobile | bucket:true" media="(max-width: 900px)">
            <source [srcset]="element.banner_mobile | bucket" media="(max-width: 900px)">
            <img class="banner-image" [src]="element.banner_desktop | bucket" fallback="images/fallback/banner.webp" alt="Premium Promo Banner"/>
        </picture>
    } @else if(!loading()) {
        <div class="text-zone text-center px-8 py-16 premium-horizontal">
            <h1 class="m-0 mat-light tz-head font-semibold">{{'PACKAGES.THIN_HEADER_TITLE' | translate}}</h1>
            <h3 class="m-0 tz-desc font-semibold">{{'PACKAGES.THIN_HEADER_TEXT' | translate}}</h3>
        </div>
    }
    <div class="banner-footer f-col f-main-center f-cross-center text-center rgap-8 mt-12 pb-12">
        <div class="ctas">
            <a [routerLink]="checkout_url()" [queryParams]="checkout_query_params()" mat-flat-button class="font-extrabold cta chevron-hover">
                <mat-icon iconPositionStart>chevron_right</mat-icon>
                {{('PACKAGES.BANNER.BUTTON'+suffix) | translate}}
                <mat-icon iconPositionEnd>chevron_left</mat-icon>
            </a>
        </div>
        @if(!is_retail()){
            <p class="m-0 px-5 disclaimer">
                {{'PACKAGES.BANNER.DISCLAIMER_YEARLY' | translate}}
            </p>
            <a class="m-0 terms font-light" [routerLink]="['/terms-and-conditions/discounts']" [fragment]="element.terms_fragment ?? 'generic'">{{'PACKAGES.BANNER.TERMS' | translate}}</a>
        }
    </div>
</div>


@if(!is_retail()){
    <!--? offer category lists -->
    <ng-container *ngTemplateOutlet="carousels"></ng-container>
    
    
    <!-- @if(element.code == 'DANUSAN'){
        <div class="video-iframe">
            <iframe width="100%" height="100%" [src]="video_url | safe:'resource'" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
        </div>
    } -->

    <div class="testimonials">
        <h1 paint="warn" class="font-bold carousel-title" [innerHTML]="'REVIEWS.TITLE' | translate"></h1>
        <div class="testimonial-container">
            <div class="quote quote-top-right">”</div>
            <div class="quote quote-bottom-left">”</div>
            <swiper-container slides-per-view="auto" pagination="true" pagination-dynamic-bullets="true" space-between="30" centered-slides="true" initial-slide="1">
                @for(item of reviews; track item.id;){
                    <swiper-slide class="review-card">
                        <h4 class="review font-regular">"{{item.review}}"</h4>
                        @if(item.premium){
                            <mat-icon paint="warn" svgIcon="premium"></mat-icon>
                        } @else {
                            <mat-icon paint="primary" svgIcon="cloudigo"></mat-icon>
                        }
                        <p class="reviewer font-bold">{{item.reviewer}}</p>
                        <div class="rating">
                            @for(star of item.ratings; track $index){
                                <mat-icon paint="accent">star</mat-icon>
                            }
                        </div>
                    </swiper-slide>
                }
            </swiper-container>
        </div>
    </div>
    
    <div class="baf">
        <img src="old/friends/premium-baf-3.webp" alt="Bring a Friend Banner" width="100%"/>
        <img src="old/friends/premium-baf-3-sm.webp" alt="Bring a Friend Banner" width="100%"/>
    </div>
} @else {
    <div class="benefits p-inset pt-15 pb-30 text-center" [class.gift]="is_retail()">
        <h1 class="font-bold section-title">{{('PACKAGES.BENEFITS_TITLE' + (is_retail() ? '_GIFT' : '')) | translate}}</h1>
        <div class="items f-main-around">
            @for(benefit of ('PACKAGES.WHY_PREMIUM_GIFT' | translate); track $index){
                <div class="item p-inset py-10 px-5 f-col f-cross-center text-center m-10">
                    <img class="icon" src="old/premium/why-premium{{benefit.INDEX}}.png" alt="Benefit Icon"/>
                    <div class="text">
                        <h2 class="mt-12 mb-6 font-bold">{{benefit.TITLE}}</h2>
                        <p>
                            {{benefit.TEXT}}
                        </p>
                    </div>
                </div>
            }
        </div>
    </div>
}


<!-- ? plan picker -->
<div inViewport (inViewportAction)="onRender($event)" [inViewportOptions]="{ threshold: [0] }" class="plans" id="packages">
    <div class="plans-container">

        @if(!is_retail()){
            <p class="plans-desc">
                {{'PLANS_LANDING.PLANPICKER_DESC' | translate}}
            </p>
            <br/>
        }

        <div class="plan-list">
            <div class="plan-container">
                @if(!is_retail()){
                    <div class="plan-box p-24 important-box">
                        <div class="value-indicator">
                            <h3 class="m-0 font-extrabold">
                                {{price_per_day() | currency}} {{'PLANS_LANDING.PLANPICKER_VALUE' | translate}}
                            </h3>
                        </div>
                        <ng-container *ngTemplateOutlet="yearlyPrice"></ng-container>
                        <ul class="benefit-list mt-20">
                            @for(benefit of ('PLANS_LANDING.PLANPICKER_YEARLY_BENEFITS' | translate); track $index){
                                <li>
                                    <mat-icon paint="warn" svgIcon="premium"></mat-icon>
                                    <span>{{benefit}}</span>
                                </li>
                            }
                        </ul>
                        <div class="cta-container mt-20">
                            <a mat-flat-button paint="warn" class="chevron-hover" [routerLink]="checkout_url()" [queryParams]="checkout_query_params()">
                                <mat-icon iconPositionStart>chevron_right</mat-icon>
                                <span>{{'PLANS_LANDING.SUBSCRIBE' | translate}}</span>
                                <mat-icon iconPositionEnd>chevron_left</mat-icon>
                            </a>
                        </div>
                    </div>
                } @else {
                    <div class="plan-box">
                        <div class="plan-box-header premium-horizontal f-col f-main-center f-cross-center">
                            <div class="plan-icon">
                                <mat-icon class="bigger-icon" svgIcon="premium"></mat-icon>
                            </div>
                            <h2 class="m-0 font-bold">{{'PACKAGES.YEARLY.GIFT_TITLE' | translate}}</h2>
                            <h3 class="m-0">{{'PACKAGES.YEARLY.GIFT_SUBTITLE' | translate}}</h3>
                        </div>
                        <div class="p-24">
                            <ng-container *ngTemplateOutlet="yearlyPrice"></ng-container>
                            <br/>
                            <div class="cta-container">
                                <a mat-flat-button class="dark-horizontal chevron-hover" [routerLink]="checkout_url()">
                                    <mat-icon iconPositionStart>chevron_right</mat-icon>
                                    <span>{{'PACKAGES.GIFT_BUY' | translate}}</span>
                                    <mat-icon iconPositionEnd>chevron_left</mat-icon>
                                </a>
                            </div>
                        </div>
                    </div>
                }
            </div>
        </div>
    </div>
</div>

@if(is_retail()){
    <ng-container *ngTemplateOutlet="carousels"></ng-container>
}

<ng-template #yearlyPrice>
    @if(discounted()){
        <span class="struck" paint="light">
            <span class="price font-bold">{{element.base_price | currency}}</span> / {{('UNIT.'+element.unit) | translate}}
        </span>
        <br/>
        <span class="unstruck">
            <span class="price uppercase font-bold">
                {{final_price() == 0 ? ('FREE' | translate) : (final_price() | currency)}}
            </span> 
            @if(!is_retail()){
                {{'PACKAGES.FIRST' | translate}} 
                {{element.duration}} {{('UNIT.days') | translate}}
            } @else {
                {{'PACKAGES.FORFA' | translate}}{{('UNIT.'+element.unit) | translate}}
            }
        </span>
        <br/>
    } @else {
        <span class="unstruck">
            <span class="font-bold price">{{'49.99' | currency}}</span> / {{'PACKAGES.YEARLY.INTERVAL' | translate}}
        </span>
        <br/>
    }
</ng-template>

<ng-template #carousels>
    <div class="carousels-container">
        <h1 paint="warn" class="font-bold carousel-title" [innerHTML]="'INSIDE_YEARLY.TITLE' | translate"></h1>
        @for(offers of offers_list(); track $index; let i = $index; let last = $last){
            @if(offers.length; as qty){
            <div class="offer-list">
                <h3 class="mt-0 mb-8 carousel-title text-left font-bold">{{'PLANS_LANDING.CATALOGUE' + (i+1) | translate}}</h3>
                <swiper-container id="offers-carousel-{{$index}}" slides-per-view="auto" navigation="true" center-insufficient-slides="true">
                    @for(offer of offers; track offer._id){
                        <swiper-slide class="offer-carousel-slide">
                            <offer-item [offer]="offer"></offer-item>
                        </swiper-slide>
                    }
                </swiper-container>
            </div>
            }
        }
        <br/>
        <a routerLink="/catalogue/premium" paint="primary">{{'PLANS_LANDING.CATALOGUE_MORE' | translate}}</a>
        <br/>
        <br/>
    </div>
</ng-template>